export default __webpack_public_path__ + "static/media/grafema_nutrana_01.fb0ed6ca.mp4";